module.exports = __webpack_public_path__ + "media/components/assets/bottle_icon_02-f1fc1f10c1a2cf9fec328134c1946b38.png";